// src/components/Shelves.js

import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import Shelf from "./Shelf";

// Create functional component
const Shelves = ({ books, updateBookShelf }) => {
    // Passed in data from APP component about books via props
    const currentlyReading = books.filter(
        (book) => book.shelf === "currentlyReading"
    );
    const wantToRead = books.filter((book) => book.shelf === "wantToRead");
    const read = books.filter((book) => book.shelf === "read");

    // Return results
    return (
        <div>
            {/* Main Page Requirement 1: Shows three reusable shelves */}
            <Shelf
                title="Currently Reading"
                books={currentlyReading}
                updateBookShelf={updateBookShelf}
            />
            <Shelf
                title="Want to Read"
                books={wantToRead}
                updateBookShelf={updateBookShelf}
            />
            <Shelf 
                title="Read" 
                books={read} 
                updateBookShelf={updateBookShelf} 
            />
        </div>
    );
};

// Add PropTypes for validation
Shelves.propTypes = {
    books: PropTypes.array.isRequired,
    updateBookShelf: PropTypes.func.isRequired,
};

export default Shelves;